import PropTypes from 'prop-types';

/**
 * Timed Component - HoC that displays child component only within a specific date and optional time range
 *
 * Usage - Default:
 * <TimedComponent start="14-01-2026" end="14-01-2026t22:34">
      <div>timed text</div>
  </TimedComponent>
 *
 * props: 1. start - The start date/time string in the format dd-mm-yyyyThh:mm if no time specified, time defaults to 00:00
 * 2. end - The end date/time string in the same format as start
 * 3. children - The child component to be displayed within the time range
 *
 *  at least start or end should be provided otherwise component doesn't do anything
 */

const TimedComponent = ({ start, end, children }) => {
  const now = new Date();

  function convertStringToDate(dateTimeString) {
    if (!dateTimeString) {
      return null;
    }
    const [datePart, timePart] = dateTimeString.toLowerCase().split('t');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart
      ? timePart.split(':').map(Number)
      : [0, 0];

    const dateObject = new Date(year, month - 1, day, hours, minutes);
    return dateObject;
  }

  const startDate = convertStringToDate(start);
  const endDate = convertStringToDate(end);

  const passStart = !startDate || (startDate && now >= startDate);
  const passEnd = !endDate || (endDate && now <= endDate);

  return passStart && passEnd ? children : null;
};

TimedComponent.propTypes = {
  start: PropTypes.string,
  end: PropTypes.string,
  children: PropTypes.any.isRequired,
};

export default TimedComponent;
